import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PATHS } from 'app/reporting/analytics/constants/analytics.constants';
import * as jQuery from 'jquery';
import * as _ from 'underscore';
import { DataTableConfig } from '../../../analytics-core/interfaces/widget.interface';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DataTableComponent } from '../datatable/datatable.component';

@Component({
	selector: 'app-ctv-platform-performance',
	styleUrls: ['./ctv-platform-performance.component.css'],
	templateUrl: './ctv-platform-performance.component.html'
})
export class CtvPlatformPerformanceComponent extends DataTableComponent implements OnInit, OnDestroy {
	@Input() datatableconfig;
	@Input() sectionclass;
	@Input() nodatamessage;
	@Input() sortdataby: any;
	@Input() downloadcsvcolumns: any;
	@Input() iscustomendpoint: any;

	public tableConfig: DataTableConfig = {} as DataTableConfig;
	public columns: any;
	public firstColumnName: any;
	public downloadCSVColumns: any;
	public isRadio: boolean;
	public downloadConfiguration: any;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
		this.isRadio = this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (!this.nodatamessage || this.nodatamessage === 'undefined' || this.nodatamessage === 'null') {
			this.nodatamessage = 'No data to display';
		}
		this.downloadConfiguration = this.downloadconfig ? JSON.parse(decodeURI(this.downloadconfig)) : undefined;
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
	}

	ngAfterViewChecked(): void {
		// Called after every check of the component's view. Applies to components only.
		// Add 'implements AfterViewChecked' to the class.
		// need to re work on this logic
		if (this.analyticsDataModel.config.version.toLowerCase() === 'r7') {
			jQuery('.custom-primary').addClass('r7_primary_bg_color');
		}
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	requestData() {
		if (this.iscustomendpoint == 'true') {
			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key)
				.subscribe((res: any) => {
					this.showLoad = false;
					this.dataTableObj.data = [];
					if (res.success && res.data.length > 0) {
						this.hasData = true;
						this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
						this.processResponseData(res.data);
					} else {
						this.hasData = false;
						this.dataTableObj.data = [];
					}
				});
		} else {
			super.requestData();
		}
	}

	impressionsComparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['impressions']) < parseFloat(d['impressions'])) {
			return 1;
		}
		if (parseFloat(c['impressions']) > parseFloat(d['impressions'])) {
			return -1;
		}
	}

	percent25Comparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['25_completions_rate']) < parseFloat(d['25_completions_rate'])) {
			return 1;
		}
		if (parseFloat(c['25_completions_rate']) > parseFloat(d['25_completions_rate'])) {
			return -1;
		}
	}

	percent50Comparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['50_completions_rate']) < parseFloat(d['50_completions_rate'])) {
			return 1;
		}
		if (parseFloat(c['50_completions_rate']) > parseFloat(d['50_completions_rate'])) {
			return -1;
		}
	}

	percent75Comparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['75_completions_rate']) < parseFloat(d['75_completions_rate'])) {
			return 1;
		}
		if (parseFloat(c['75_completions_rate']) > parseFloat(d['75_completions_rate'])) {
			return -1;
		}
	}

	percent100Comparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c['100_completions_rate']) < parseFloat(d['100_completions_rate'])) {
			return 1;
		}
		if (parseFloat(c['100_completions_rate']) > parseFloat(d['100_completions_rate'])) {
			return -1;
		}
	}

	platformComparator(a: any, b: any, c: any, d: any): number {
		if (c['platform_name'].toLowerCase() < d['platform_name'].toLowerCase()) {
			return -1;
		}
		if (c['platform_name'].toLowerCase() > d['platform_name'].toLowerCase()) {
			return 1;
		}
	}

	processResponseData(responseData: any): void {
		this.generateDateTableConfiguration(responseData);
	}

	generateDateTableConfiguration(responseData: any): void {
		this.dataTableObj.data = this.generateResponseDataFromConfig(responseData);
		this.dataTableObj.data = this.sortdataby
			? _.sortBy(_.sortBy(this.dataTableObj.data, 'plotform_name').reverse(), 'impressions').reverse()
			: this.dataTableObj.data;
		this.firstColumnName = this.dataTableObj.columns[0]['name'];
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.tableConfig.csvQueryKey
				? this.tableConfig.csvQueryKey
				: this.downloadConfiguration.csvQueryKey
				? this.downloadConfiguration.csvQueryKey
				: this.key,
			this.tableConfig.downloadFileName ? this.tableConfig.downloadFileName : this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}
}
